import React, { useState, useEffect, useCallback, useRef } from "react";
import { ToastContainer } from "react-toastify";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { poppinsCustomTheme } from "../../Styles/GlobalStyles/PoppinsTheme";
import { ThemeProvider } from "@mui/material/styles";
import Slide from "@mui/material/Slide";
import { GreyOutlinedButton } from "../Button/CustomButton";
import { colors, Typography } from "../../Styles/GlobalStyles/Variables";
import TextField from "@mui/material/TextField";
import { FormControl, Box, Divider, Link, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  emptySkillSet,
  fetchSkillSet,
  restoreSkillSetInitial,
  addSubSkills,
  fetchAllTotalSkillsData,
  importSubSkill,
} from "../../Actions";
import { useSelector, useDispatch } from "react-redux";
import LoadingButton from "@mui/lab/LoadingButton";
import generalFunc from "../../Utils/generalFunc";
import { IconButton } from "@mui/material";
import CustomizedTabs from "./CustomizedTabs";
import Iconify from "../Dashboard/Iconify";
import FileSaver from "file-saver";
import { SubSkillFile } from "../ExcelFiles/subskill";
import { useDropzone } from "react-dropzone";
import {
  DropActiveText,
  DropZoneFooter,
  DropZoneText,
  TemplateNameSection,
  TemplateZone,
  dragdropActive,
  dragdropZone,
  errorColor,
  fileNameSection,
  filesUploadedZone,
} from "../../Styles/DragnDrop";
import { BulkUploadBeforeIcon } from "../Icons/FileUploadIcons";
import BulkUploadAfterIcon from "../Icons/BulkUploadAfterIcon.gif";

const getSubSkillState = (state) => state.skillsReducer;
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AddSubSkillDialog(props) {
  const theme = useTheme();
  const {
    openNewSubSkillDialog,
    handleCloseNewSubSkillDialog,
    subSkillId,
    updateLoadingState,
    theParams,
  } = props;
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const ToastStyle = {
    backgroundColor: "#d56b66",
    color: colors.white,
  };

  const initialFormValues = {
    name: "",
    skillId: subSkillId,
  };

  const subSkillList = [];
  const { subSkillsCreated, subSkillBulkUploadData } =
    useSelector(getSubSkillState);
  const dispatch = useDispatch();
  const initialState = JSON.parse(JSON.stringify(initialFormValues));

  const [formValues, setFormValues] = useState(initialState);
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");
  const [loadingButton, setLoadingButton] = useState(false);
  const [disable, setDisable] = useState(colors.primaryGreen);
  const [value, setValue] = React.useState(0);
  const [bulkFileUpload, setBulkFileUpload] = useState(null);
  const initialBulkFileValues = {
    name: "",
    path: "",
    size: "",
    display: false,
    error: false,
    emptyError: false,
  };
  const [bulkFile, setBulkFile] = useState(initialBulkFileValues);

  const uploadedItemRef = useRef(null);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleDeleteFile = () => {
    setBulkFile(initialBulkFileValues);
    setBulkFileUpload(null);
  };
  function MyDropzone() {
    const onDrop = useCallback((acceptedFiles) => {
      uploadedItemRef?.current?.scrollIntoView({ behavior: "smooth" });
      acceptedFiles.forEach((file) => {
        const reader = new FileReader();
        reader.onabort = () => console.log("file reading was aborted");
        reader.onerror = () => console.log("file reading has failed");
        reader.onload = () => {
          // Do whatever you want with the file contents
          const binaryStr = reader.result;
          console.log(binaryStr, "binarystring");
          console.log(reader, "reader");
          console.log(file, "file");
          if (!file.name.match(/\.(xlsx)$/)) {
            setBulkFile({
              ...bulkFile,
              error: true,
              display: false,
              name: "",
              path: "",
              size: "",
            });
            setBulkFileUpload(null);
            return false;
          } else {
            setBulkFileUpload(file);
            setBulkFile({
              ...bulkFile,
              name: file.name,
              size: file.size,
              display: true,
              error: false,
              emptyError: false,
            });
          }
        };
        reader.readAsArrayBuffer(file);
        console.log(reader.readAsArrayBuffer(file), "as array buffer");
      });
    }, []);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
      onDrop,
    });

    return (
      <>
        <div
          style={isDragActive ? dragdropActive : dragdropZone}
          {...getRootProps()}
        >
          <div>
            {/* <img src={Folder} alt="folder" width="70px" height="50px" /> */}
          </div>
          <br />
          <input {...getInputProps()} />
          {isDragActive ? (
            <>
              <div style={{ textAlign: "center" }}>
                <img
                  src={BulkUploadAfterIcon}
                  alt="file upload"
                  width={50}
                  height={50}
                />
                <p style={DropActiveText}>
                  {" "}
                  <b>Drop file here...</b>
                </p>
              </div>
            </>
          ) : (
            <>
              <div style={{ textAlign: "center" }}>
                <BulkUploadBeforeIcon />
                <p style={DropZoneText}>Upload the filled-in template here</p>
                <p style={{ fontSize: "10px" }}>
                  Drag and drop, or click to select
                </p>
              </div>
            </>
          )}
        </div>
        <div style={DropZoneFooter}>
          <div>
            <p>File must be in .xlsx</p>
          </div>
          <div>
            <p>Maximum Size: 20MB</p>
          </div>
        </div>
      </>
    );
  }

  const handleDownload = (e) => {
    e.preventDefault();
    // let dataBlob = SkillSetExcelFile;
    let sliceSize = 1024;
    let byteCharacters = atob(SubSkillFile);
    let bytelength = byteCharacters.length;
    let sliceCount = Math.ceil(bytelength / sliceSize);
    let byteArrays = new Array(sliceCount);
    for (let sliceIndex = 0; sliceIndex < sliceCount; ++sliceIndex) {
      let begin = sliceIndex * sliceSize;
      let end = Math.min(begin + sliceSize, bytelength);
      let bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    let blob = new Blob(byteArrays, { type: "application/vnd.ms-excel" });
    FileSaver.saveAs(new Blob([blob], {}), "Sub Skill Upload Template.xlsx");
  };
  //   useEffect(()=>{
  //     setFormValues({...formValues, skillId:subSkillId})
  //     console.log(subSkillId, "Test Purposes");
  //     console.log(formValues.skillId, "if it updated")
  // })

  function resetForm() {
    setFormValues({
      ...formValues,
      name: "",
      skillId: 0,
    });

    setBulkFile(initialBulkFileValues);
    setBulkFileUpload(null);
  }

  const handleSubSkillInput = (e) => {
    if (e) {
      e.preventDefault();
      let subSkillValue = e.target.value;
      setLoadingButton(false);
      setFormValues({
        ...formValues,
        name: subSkillValue,
      });
      setError(false);
      setHelperText("");
    } else {
      /* setFormValues({
        ...formValues,
        name: "",
        skillId: 0,
      }); */
    }
  };

  // const handleAddition = () => {
  //   setSubSkillList([...subSkill]);
  // };
  const addBulkUploadSubSkill = () => {
    debugger;
    if (bulkFile?.name !== "") {
      console.log(bulkFileUpload, "sweet");
      const formData = new FormData();
      formData.append("SkillId", subSkillId);
      formData.append("File", bulkFileUpload);
      dispatch(importSubSkill(formData));
      setLoadingButton(true);
      setDisable(colors.secondaryGreen);
    } else {
      setBulkFile({ ...bulkFile, emptyError: true });
    }
    setTimeout(() => {
      if (dispatch) {
        setLoadingButton(false);
      }
    }, 2000);
  };
  const addNewSubSkill = () => {
    const newFormValues = {
      ...formValues,
      name: formValues.name,
      skillId: subSkillId,
    };
    setFormValues(newFormValues);
    if (
      newFormValues.skillId !== 0 &&
      formValues.name.length > 0 &&
      formValues.name !== null &&
      formValues.name !== undefined &&
      formValues.name.trim()
    ) {
      dispatch(addSubSkills(newFormValues));
      setLoadingButton(true);
      setDisable(colors.secondaryGreen);
    } else {
      /*   if(formValues.name !== null && formValues.name !=="" && formValues.name !==undefined){
      dispatch(addSkillSet(formValues));
      setLoadingButton(true);
      setDisable(colors.secondaryGreen);
      // setLoading(true)
    } */
      setError(true);
      setHelperText("Sub skill name is required");
    }
    setTimeout(() => {
      if (dispatch) {
        setLoadingButton(false);
      }
    }, 900);
  };

  const handleClose = () => {
    setLoadingButton(false);
    resetForm();
    handleCloseNewSubSkillDialog();
    setError(false);
    setHelperText("");
  };
  //this effect checks if subskill  is created and then closes the dialog and resetForm
  useEffect(() => {
    if (subSkillsCreated === true || subSkillBulkUploadData === true) {
      handleCloseNewSubSkillDialog();
      updateLoadingState();
      dispatch(fetchSkillSet(theParams));
      dispatch(fetchAllTotalSkillsData());
      resetForm();
      setError(false);
      setHelperText("");
    }
    return () => {
      dispatch(emptySkillSet());
      dispatch(restoreSkillSetInitial());
    };
  }, [subSkillsCreated, subSkillBulkUploadData, dispatch]);

  return (
    <ThemeProvider theme={poppinsCustomTheme}>
      <Dialog
        fullWidth={true}
        fullScreen={fullScreen}
        open={openNewSubSkillDialog}
        TransitionComponent={Transition}
        keepMounted
        aria-labelledby="draggable-dialog-title"
        PaperProps={{
          style: { borderRadius: 20, padding: 10 },
        }}
      >
        <DialogTitle
          sx={{
            fontSize: "20px",
            fontWeight: 700,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          id="responsive-dialog-title"
        >
          Add New Sub-skill
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{ padding: "0px 10px", textTransform: "capitalize" }}
        >
          <CustomizedTabs
            value={value}
            handleChange={handleChange}
            Item1={
              <Box
                component="form"
                sx={{ p: 2, fontFamily: "Public Sans, sans-serif" }}
                noValidate
                autoComplete="off"
              >
                <FormControl variant="outlined" fullWidth>
                  <label style={{ marginBottom: "10px" }} htmlFor="skill">
                    Sub Skill
                  </label>
                  <TextField
                    helperText={helperText}
                    inputProps={{
                      spellCheck: true,
                      lang: "English",
                    }}
                    onChange={(e) => {
                      handleSubSkillInput(e);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        addNewSubSkill(e);
                      }
                    }}
                    value={generalFunc.firstLetterUppercase(formValues.name)}
                    error={error}
                    size="small"
                    id="skill"
                    variant="outlined"
                  />
                </FormControl>
                <br />
                <br />
                {/* <Button
                onClick={handleAddition}
                disableRipple
                startIcon={<AddIcon />}
                sx={{ textTransform: "capitalize" }}
              >
                Add another
              </Button> */}
                {subSkillList.map((item, index) => {
                  return <p key={index}>{item.subSkill}</p>;
                })}
              </Box>
            }
            Item2={
              <Box
                component="form"
                sx={{
                  "& > :not(style)": { pt: 2, pb: 0, pl: 2 },
                  fontFamily: Typography.secondaryFont,
                  textTransform: "initial",
                }}
                noValidate
                autoComplete="off"
              >
                <Box>
                  <div style={{ marginTop: "0px" }}>
                    {bulkFile.error ? (
                      <p style={errorColor}>
                        You can only upload file in .XLSX format{" "}
                      </p>
                    ) : bulkFile.emptyError ? (
                      <p style={errorColor}>Please upload a file to submit</p>
                    ) : (
                      ""
                    )}
                    <MyDropzone />
                  </div>
                  {bulkFile.display ? (
                    <div style={filesUploadedZone} ref={uploadedItemRef}>
                      <div style={fileNameSection}>
                        <div
                          style={{
                            backgroundColor: "#fff",
                            padding: "7px",
                            border: "1.3px solid #e0e0e0",
                            borderRadius: "7pX",
                            width: "fit-content",
                          }}
                        >
                          <Iconify
                            icon="vscode-icons:file-type-excel"
                            style={{ width: "30px", height: "30px" }}
                          />
                        </div>
                        <div>
                          <p style={{ fontWeight: 600 }}>{bulkFile.name}</p>
                          <p style={{ marginTop: "10px", fontWeight: 400 }}>
                            {Math.round(bulkFile.size / 1024)} KB
                          </p>
                        </div>
                      </div>
                      <>
                        <IconButton
                          size="small"
                          sx={{ marginTop: "-15px" }}
                          onClick={handleDeleteFile}
                        >
                          <CloseIcon sx={{ fontSize: "1.2rem" }} />
                        </IconButton>
                      </>
                    </div>
                  ) : (
                    <div style={TemplateZone} ref={uploadedItemRef}>
                      <div>
                        <div style={TemplateNameSection}>
                          <div>
                            {" "}
                            <Iconify
                              icon="vscode-icons:file-type-excel"
                              style={{ width: "30px", height: "30px" }}
                            />
                          </div>

                          <div>
                            <p style={{ fontWeight: 600 }}>
                              Sub Skill Upload Template
                            </p>
                          </div>
                        </div>
                        <div>
                          <p
                            style={{
                              marginTop: "10px",
                              fontWeight: 400,
                              color: "9DA3AA",
                              width: "90%",
                            }}
                          >
                            Download the sample template by clicking on the
                            download button. Add your data to the template file
                            and upload the file for submission.{" "}
                          </p>
                        </div>
                      </div>
                      <>
                        <Button
                          onClick={handleDownload}
                          variant="outlined"
                          disableElevation
                          sx={{
                            fontSize: "13px",
                            padding: "10px 25px",
                            background: "#fff",
                            border: "1.3px solid #e0e0e0",
                            borderRadius: "5px",
                            textTransform: "initial",
                            color: "gray",
                            "&:hover": { background: "#fff", color: "#016c34" },
                          }}
                        >
                          Download
                        </Button>
                      </>
                    </div>
                  )}
                </Box>
              </Box>
            }
          />
        </DialogContent>
        {/* <Divider/> */}
        <DialogActions sx={{ textTransform: "capitalize", p: 3 }}>
          <GreyOutlinedButton
            sx={{ fontFamily: Typography.secondaryFont, padding: "10px 25px" }}
            autoFocus
            onClick={handleClose}
          >
            Cancel
          </GreyOutlinedButton>
          <LoadingButton
            color="primary"
            sx={{
              padding: "10px 25px",
              fontFamily: Typography.secondaryFont,
              color: colors.white,
              backgroundColor: disable,
              textTransform: "inherit",
              // padding: theme.spacing(2),
              "&:hover": {
                backgroundColor: colors.darkGreen,
              },
            }}
            onClick={value === 0 ? addNewSubSkill : addBulkUploadSubSkill}
            autoFocus
            loading={loadingButton}
            // loadingIndicator="Adding..."
          >
            Add Skill
          </LoadingButton>
        </DialogActions>
        <ToastContainer toastStyle={ToastStyle} />
      </Dialog>
    </ThemeProvider>
  );
}
